<div class="title">{{ label }}</div>
<div class="check {{ userClass1 }}" *ngIf="_list && _list.length > 0">
  <!--#rbl="ngModel"-->
  <div *ngFor="let item of _list" class="{{ userClass2 }}">
    <label class="checkbox" style="{{ userClass2 ? 'margin-right:-18px;margin-left: 40px;' : '' }}">
      <input
        type="checkbox"
        id="{{ name }}"
        [name]="item.Id"
        tabindex="{{ tabOrder }}"
        [value]="item.Id"
        [(ngModel)]="item.Selected"
        required="{{ required }}"
        [checked]="isSelect(item.Id)"
        [disabled]="disabled"
        (ngModelChange)="onChange(item)"
        #rbl="ngModel" />
      {{ item.Title }}
      <div class="checkmark"></div>
    </label>
    <div [hidden]="rbl.valid || rbl.pristine" class="alert alert-danger">{{ name }} is required</div>
  </div>
</div>
